import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import ClientsModal from "./clientModal";
import { tokens } from "../../theme";
import { IconClients, IconPlus } from "../ui/icons";
import { getInitials } from "../../utils/initials";

/**
 * Tarjeta del cliente de la orden. Antes eran tres etiquetas sueltas con un "+"
 * verde al costado; ahora es una sola tarjeta que dice si hay cliente o no.
 */
const Client = ({ showIcon = false, formState, setFormState, isReadOnlyMode }) => {
  const [openModal, setOpenModal] = useState(false);
  const client = formState.client;
  const hasClient = Boolean(client?.name || client?.company);
  const canChange = showIcon && !isReadOnlyMode;

  return (
    <>
      {hasClient ? (
        <Box
          className="client_container"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            backgroundColor: tokens.surface,
            border: `1px solid ${tokens.border}`,
            borderRadius: `${tokens.radiusCard}px`,
            padding: "13px 14px",
            minHeight: 70,
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 40,
              flexShrink: 0,
              borderRadius: "11px",
              backgroundColor: tokens.borderSoft,
              color: tokens.ink2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
              fontWeight: 600,
            }}
          >
            {getInitials(client?.company || client?.name)}
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", gap: "2px", flexGrow: 1, minWidth: 0 }}>
            <Typography
              sx={{
                fontSize: { xs: "14.5px", md: "15px" },
                fontWeight: 500,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {client?.company || client?.name}
            </Typography>
            <Typography
              sx={{
                fontSize: "11.5px",
                color: tokens.ink3,
                fontVariantNumeric: "tabular-nums",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {[client?.cuit, client?.name, client?.address].filter(Boolean).join(" · ") ||
                "Sin datos de contacto"}
            </Typography>
          </Box>

          {canChange && (
            <Box
              onClick={() => setOpenModal(true)}
              role="button"
              aria-label="Cambiar cliente"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: 44,
                padding: { xs: "0 8px", md: "0 13px" },
                border: { md: `1px solid ${tokens.border}` },
                borderRadius: `${tokens.radiusControl}px`,
                fontSize: "12.5px",
                fontWeight: 500,
                color: { xs: tokens.brandDark, md: tokens.ink2 },
                cursor: "pointer",
                flexShrink: 0,
                whiteSpace: "nowrap",
                "&:hover": { backgroundColor: tokens.borderSoft },
              }}
            >
              Cambiar
            </Box>
          )}
        </Box>
      ) : (
        <Box
          onClick={canChange ? () => setOpenModal(true) : undefined}
          role={canChange ? "button" : undefined}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            backgroundColor: tokens.surface,
            border: `1px dashed ${canChange ? tokens.brand : tokens.borderStrong}`,
            borderRadius: `${tokens.radiusCard}px`,
            padding: "13px 14px",
            minHeight: 70,
            cursor: canChange ? "pointer" : "default",
            "&:hover": canChange ? { backgroundColor: tokens.brandTint2 } : undefined,
          }}
        >
          <Box
            sx={{
              width: 40,
              height: 40,
              flexShrink: 0,
              borderRadius: "11px",
              backgroundColor: tokens.brandTint,
              color: tokens.brandDark,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <IconClients size={19} />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "2px", flexGrow: 1, minWidth: 0 }}>
            <Typography sx={{ fontSize: "14.5px", fontWeight: 500 }}>Elegí el cliente</Typography>
            <Typography sx={{ fontSize: "11.5px", color: tokens.ink3 }}>
              Sin cliente no se puede avanzar
            </Typography>
          </Box>
          {canChange && (
            <Box
              sx={{
                width: 36,
                height: 36,
                flexShrink: 0,
                borderRadius: 999,
                backgroundColor: tokens.brand,
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <IconPlus size={19} />
            </Box>
          )}
        </Box>
      )}

      {!isReadOnlyMode && (
        <ClientsModal
          open={openModal}
          setOpen={setOpenModal}
          setFormState={setFormState}
          formState={formState}
        />
      )}
    </>
  );
};

export default Client;
